import { SvgIcon } from '@mui/material';

import type * as React from 'react';
import type { BaseIconProps } from '../types';

export const CalendarAppointmentIcon: React.FC<BaseIconProps> = (props) => {
  return (
    <SvgIcon fillRule="evenodd" stroke="none" {...props}>
      {/* eslint-disable-next-line max-len */}
      <path d="M12 14a2 2 0 100-4 2 2 0 000 4zM12 15c-1.335 0-4 .67-4 2v1h8v-1c0-1.33-2.665-2-4-2z" />
      {/* eslint-disable-next-line max-len */}
      <path d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z" />
    </SvgIcon>
  );
};
